// extracted by mini-css-extract-plugin
module.exports = {"empty":"jOQKF","message":"_5MRoq"};